import { render, staticRenderFns } from "./Instrucciones.vue?vue&type=template&id=67715de1&"
import script from "./Instrucciones.vue?vue&type=script&lang=js&"
export * from "./Instrucciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports